import React from 'react';
import Icon from '../../../../components/Icon/Icon';
import { currencyToSign } from '../../../../utils/utils';

const getPixelReward = ({ text_summ = '', summ = '', currency }) =>
  text_summ ? text_summ : `${summ} ${currencyToSign(currency)}`;

const OffersPixels = ({ pixels, isCollapsed, collapsedItems }) =>
  pixels.length > 0 && (
    <div className="offers-list-table-cell">
      <ul className="offer-pixels-list offer-values-list list-unstyled no-margin">
        {pixels.map((pixel, index) => {
          if (!isCollapsed || index < collapsedItems) {
            return (
              <li className="offer-pixel-item text-right" key={`pixel_${pixel.id}`}>
                {pixel.device && pixel.device.includes('mobile') && <Icon type="mobile" className="mr-1" />}
                {pixel.device && pixel.device.includes('desktop') && <Icon type="monitor" className="mr-1" />}
                <span className="offer-pixel-value">{getPixelReward(pixel)}</span>
              </li>
            );
          }
          return null;
        })}
      </ul>
    </div>
  );

export default OffersPixels;
